/**
 * 投票时间段配置（前端写死，后续由后端接口返回）
 * 修改 START / END 即可调整投票窗口
 *  8月14日13:30分到8月15日16：00
 */
const VOTE_START = new Date('2026-08-14 10:00:00')
const VOTE_END   = new Date('2026-08-15 16:00:00')

const STATUS = {
  BEFORE: 'before',   // 未开始
  DURING: 'during',   // 进行中
  AFTER:  'after'     // 已结束
}

/** 获取当前投票状态 */
export function getVoteStatus() {
  const now = new Date()
  if (now < VOTE_START) return STATUS.BEFORE
  if (now > VOTE_END)   return STATUS.AFTER
  return STATUS.DURING
}

/** 能否投票（仅校验结束时间，忽略开始时间以便随时测试） */
export function canVote() {
  const now = new Date()
  return now <= VOTE_END
}

/** 倒计时目标时间（毫秒） */
export function getTargetTime() {
  const s = getVoteStatus()
  if (s === STATUS.BEFORE) return VOTE_START.getTime()
  if (s === STATUS.DURING) return VOTE_END.getTime()
  return null
}

/** 格式化倒计时字符串 */
export function getCountdownText(lang) {
  const target = getTargetTime()
  if (target === null) return ''
  const now = Date.now()
  const diff = target - now
  if (diff <= 0) return ''

  const isZh = lang === 'zh'
  const dayUnit = isZh ? '天' : 'hari'
  const hourUnit = isZh ? '时' : 'jam'
  const minUnit = isZh ? '分' : 'menit'
  const secUnit = isZh ? '秒' : 'detik'

  const d = Math.floor(diff / 86400000)
  const h = Math.floor((diff % 86400000) / 3600000)
  const m = Math.floor((diff % 3600000) / 60000)
  const s = Math.floor((diff % 60000) / 1000)

  if (d > 0) return `${d}${dayUnit}${h}${hourUnit}${m}${minUnit}${s}${secUnit}`
  if (h > 0) return `${h}${hourUnit}${m}${minUnit}${s}${secUnit}`
  if (m > 0) return `${m}${minUnit}${s}${secUnit}`
  return `${s}${secUnit}`
}

/** 格式化日期时间 */
export function formatDate(date, lang) {
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  const h = String(date.getHours()).padStart(2, '0')
  const min = String(date.getMinutes()).padStart(2, '0')
  const s = String(date.getSeconds()).padStart(2, '0')
  const isZh = lang === 'zh'
  const time = `${h}:${min}:${s}`
  return isZh ? `${m}月${d}日 ${time}` : `${d}-${m} ${time}`
}

/** 获取状态描述信息 */
export function getStatusInfo(lang) {
  const s = getVoteStatus()
  const isZh = lang === 'zh'
  if (s === STATUS.BEFORE) {
    return {
      status: 'before',
      label: isZh ? '距投票开始' : 'Menuju Mulainya Voting',
      countdown: getCountdownText(lang),
      timeRange: `${formatDate(VOTE_START, lang)} — ${formatDate(VOTE_END, lang)}`,
      toastMsg: isZh ? '投票尚未开始，请耐心等待' : 'Voting belum dimulai, harap menunggu'
    }
  }
  if (s === STATUS.DURING) {
    return {
      status: 'during',
      label: isZh ? '距投票结束' : 'Menuju Berakhirnya Voting',
      countdown: getCountdownText(lang),
      timeRange: `${formatDate(VOTE_START, lang)} — ${formatDate(VOTE_END, lang)}`,
      toastMsg: ''
    }
  }
  return {
    status: 'after',
    label: isZh ? '投票已结束' : 'Voting Berakhir',
    countdown: '',
    timeRange: `${formatDate(VOTE_START, lang)} — ${formatDate(VOTE_END, lang)}`,
    toastMsg: isZh ? '投票已结束，感谢您的参与' : 'Voting berakhir, terima kasih atas partisipasi Anda'
  }
}

export { VOTE_START, VOTE_END, STATUS }



// WEBPACK FOOTER //
// ./src/utils/voteTime.js